import { render, staticRenderFns } from "./BottomCornerPopup.vue?vue&type=template&id=f7e01764&scoped=true"
import script from "./BottomCornerPopup.vue?vue&type=script&lang=js"
export * from "./BottomCornerPopup.vue?vue&type=script&lang=js"
import style0 from "./BottomCornerPopup.vue?vue&type=style&index=0&id=f7e01764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e01764",
  null
  
)

export default component.exports